module.exports = __webpack_public_path__ + "../resources/img/Icon_Arrow_Left_Color.1e047c66.svg";